import { useEffect, useRef, useState } from 'react';
import { getCookie, setCookie } from 'src/functions/cookies';
import { ECookie } from './useCookies.enums';
import { _isReloadNeeded } from './useCookies.functions';
import { cookiesData } from './useCookies.variables';

const useCookies = () => {
	const [activatedCookiesType, setActivatedCookiesType] = useState<ECookie[]>(
		cookiesData.filter((cookie) => !!getCookie(cookie.type)).map((cookie) => cookie.type)
	);

	// ephemeral variable to store the state before the user edition (to know if a reload is needed)
	const savedCookieConsentTypes = useRef<ECookie[] | undefined>();

	const isReloadNeeded = _isReloadNeeded(activatedCookiesType, savedCookieConsentTypes.current);

	const updateActivatedCookie = (type: ECookie) => {
		if (activatedCookiesType.includes(type)) {
			setActivatedCookiesType(activatedCookiesType.filter((cookieType) => cookieType !== type));
		} else {
			setActivatedCookiesType([...activatedCookiesType, type]);
		}
	};

	// accept all cookies
	const acceptAllCookies = () => setActivatedCookiesType(cookiesData.map(({ type }) => type));
	// reject all cookies
	const rejectAllCookies = () => setActivatedCookiesType([]);

	useEffect(() => {
		// set cookies
		cookiesData
			.filter(({ type }) => type !== ECookie.essentials)
			.forEach(({ type }) => {
				setCookie(type, activatedCookiesType.includes(type), 365);
			});

		// store state before editions
		if (!savedCookieConsentTypes.current) {
			savedCookieConsentTypes.current = activatedCookiesType;
		}
	}, [activatedCookiesType]);

	return {
		acceptAllCookies,
		rejectAllCookies,
		updateActivatedCookie,
		activatedCookiesType,
		isReloadNeeded
	};
};

export { useCookies };
